export const ENV = {
  HIDE_LOGO: process.env.REACT_APP_HIDE_LOGO === "TRUE",
  HIDE_TRANSLATOR: process.env.REACT_APP_HIDE_TRANSLATOR === "TRUE",
};
